var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        entity: _vm.currentBuyer,
        title: _vm.$t("RESET_COUNTERS_MODAL_HEADER", { target: "Buyer" }),
        "cancel-button-text": _vm.$t("CANCEL"),
        "confirm-action-text": _vm.$t("RESET_COUNTERS_MODAL_YES"),
        "confirm-button-loading": _vm.isBuyerResetCapCountersLoading
      },
      on: {
        confirm: function($event) {
          return _vm.$emit("confirm", _vm.currentBuyer)
        },
        close: function($event) {
          return _vm.$emit("close", _vm.currentBuyer)
        }
      }
    },
    [
      _c("span", [
        _vm._v(_vm._s(_vm.$t("RESET_COUNTERS_MODAL_BODY", { target: "Buyer" })))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }